// Socket.io event constants and payload types

export const SOCKET_EVENTS = {
  // Server → client
  MAIL_NEW: 'mail:new',
  MAIL_DELETED: 'mail:deleted',
  MAIL_RESTORED: 'mail:restored',
  MAIL_PURGED: 'mail:purged',
  MAIL_READ: 'mail:read',
  MAIL_STARRED: 'mail:starred',
  ASSIGNMENT_CHANGED: 'assignment:changed',
  CLIENT_STATUS: 'client:status',
  SETTINGS_UPDATED: 'settings:updated',
  USER_DELETED: 'user:deleted',
} as const;

export interface MailNewPayload {
  email_id: string;
  mailbox_id: string;
  mailbox_full_address: string | null;
  mailbox_visible: boolean;
  from_addr: string;
  from_name: string | null;
  subject: string | null;
  snippet: string | null;
  received_at: number;
  has_attachments: boolean;
}

export interface MailDeletedPayload {
  email_id: string;
}

export interface MailRestoredPayload {
  email_id: string;
}

export interface MailPurgedPayload {
  email_id: string;
}

export interface MailReadPayload {
  email_id: string;
  user_id: string;
  is_read: boolean;
}

export interface MailStarredPayload {
  email_id: string;
  user_id: string;
  is_starred: boolean;
}

export interface AssignmentChangedPayload {
  client_id: string;
  mailbox_id: string;
  action: 'assigned' | 'unassigned' | 'source_toggled';
  can_see_source?: boolean;
}

export interface ClientStatusPayload {
  user_id: string;
  status: 'pending' | 'approved' | 'rejected' | 'suspended';
}